module.exports = __webpack_public_path__ + "img/time.31126d0f.svg";